import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useShouldShowNewEventsLayout } from '@ms/yammer-hooks/dist/routes';
import PageLayout from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import {
  articleEditPageMatchPath,
  articleNewMatchPath,
  articlePageMatchPath,
  eventPageMatchPath,
} from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Page from '../Page';

import { ContentRoutes } from './ContentRoutes';
import { useRenderArticleFooterCallback } from './hooks';
import {
  Article,
  ArticleEdit,
  ArticleNew,
  GroupInsights,
  LiveEvent,
  Logout,
  MediaPostImmersiveView,
  UserInsights,
} from './loadableComponents';

const Routes: FC = () => {
  const shouldShowNewEventsLayout = useShouldShowNewEventsLayout();
  const userInsightsExperimentEnabled = useExperimentTreatmentWithoutReporting(Experiment.UserInsights) === true;
  const isMediaPostEnabled = useExperimentTreatmentWithoutReporting(Experiment.StorylineMediaPost) === true;
  const renderArticleFooter = useRenderArticleFooterCallback();

  const userInsightsPage = userInsightsExperimentEnabled ? (
    <Route path="/users/:userId/insights">
      <Page>
        <UserInsights />
      </Page>
    </Route>
  ) : null;

  const mediaPostImmersiveViewRoute = isMediaPostEnabled ? (
    <Route exact={true} path="/media-post/:threadId">
      <MediaPostImmersiveView />
    </Route>
  ) : (
    <Redirect from="/media-post/:threadId" to="/threads/:threadId" exact={true} />
  );

  return (
    <Switch>
      <Route path={eventPageMatchPath}>
        <Page
          collapseLeftSidebar={shouldShowNewEventsLayout}
          noScroll={shouldShowNewEventsLayout}
          noSpacing={shouldShowNewEventsLayout}
        >
          <LiveEvent />
        </Page>
      </Route>
      <Route exact={true} path={articleNewMatchPath}>
        <Page backgroundColor="white" isLeftSidebarEnabled={false}>
          <ArticleNew />
        </Page>
      </Route>
      <Route exact={true} path={articleEditPageMatchPath}>
        <Page backgroundColor="white" isLeftSidebarEnabled={false}>
          <ArticleEdit />
        </Page>
      </Route>
      <Route exact={true} path={articlePageMatchPath}>
        <Page backgroundColor="white" isLeftSidebarEnabled={false} onRenderFooter={renderArticleFooter}>
          <Article />
        </Page>
      </Route>
      <Route path="/groups/:groupId/activity">
        <Page>
          <GroupInsights />
        </Page>
      </Route>
      {mediaPostImmersiveViewRoute}
      {userInsightsPage}
      <Route path="/logout">
        <PageLayout>
          <Logout />
        </PageLayout>
      </Route>
      <Route default={true}>
        <Page>
          <ContentRoutes />
        </Page>
      </Route>
    </Switch>
  );
};

export default Routes;
